import client from '@/clients/customer/api-client';
import Qs from 'qs';
import { fetchCachedSettings } from './settings';
import { getCachedPages } from './pages';

export const getForVendorsData = (filter: any | null = null, headers = {}) =>
  client.get('/for-vendors', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers,
  });

export const getVendorFAQs = (filter: any | null = null, headers = {}) =>
  client.get('/faqs', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers,
  });

export async function fetchAppSettingsAndPages(locale: string) {
  let appSettingsData;

  const results = await Promise.allSettled([
    fetchCachedSettings({
      'Accept-Language': locale,
    }),
  ]);

  const [settingsResult] = results;

  if (settingsResult.status === 'fulfilled') {
    appSettingsData = settingsResult.value.data;
  } else {
    // console.error('Failed to fetch settings:', settingsResult.reason);
    console.error('Failed to fetch settings');
  }

  return appSettingsData ?? null;
}
